import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { gameCodeCapsuleStyles } from "./rangeGameStyles";
import { showSnackbar } from "../SharedComponents/Notifier";
import { copyText, fallbackCopy } from "../../utils/text";

type Props = {
  code: string;
  className?: string;
  size?: "default" | "small";
};

const GameCodeCapsule = ({ code, className, size = "default" }: Props) => {
  const classes = useStyles();

  const copyGameCode = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    copyText(code)
      .then(() => showSnackbar(`Copied ${code}`, 2000, "success"))
      .catch(() => {
        try {
          fallbackCopy(code);
          showSnackbar(`Copied ${code}`, 2000, "success");
        } catch {
          showSnackbar("Could not copy game code", 3000, "warning");
        }
      });
  };

  const capsuleClass = [
    classes.capsule,
    size === "small" ? classes.capsuleSmall : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={capsuleClass}
      aria-label={`Copy game code ${code}`}
      title="Copy game code"
      onMouseDown={event => event.stopPropagation()}
      onClick={copyGameCode}
    >
      {code}
    </button>
  );
};

const useStyles = makeStyles({
  capsule: {
    ...gameCodeCapsuleStyles,
    fontFeatureSettings: '"tnum"',
  },
  capsuleSmall: {
    height: 18,
    padding: "0 6px",
    fontSize: "0.6875rem",
    letterSpacing: "0.05em",
  },
});

export default GameCodeCapsule;
